import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", { d: "M20.336 3.221L3.873 8.71a.35.35 0 00-.027.654l6.05 2.593a.2.2 0 00.196-.021l5.931-4.238c.184-.13.41.096.28.28l-4.238 5.931a.2.2 0 00-.02.195l2.592 6.05a.35.35 0 00.654-.026L20.78 3.664a.35.35 0 00-.443-.443z" })
  ]))
}